import React from 'react';

const FloatingCards = () => {
    return (
        <div className="floating-cards">
            <div className="floating-card">
                <h4>AI Solutions</h4>
                <p>Smart automation</p>
            </div>
            <div className="floating-card">
                <h4>Enterprise Focus</h4>
                <p>Scalable systems</p>
            </div>
            <div className="floating-card">
                <h4>Innovation</h4>
                <p>Cutting-edge tech</p>
            </div>
        </div>
    );
};

export default FloatingCards;